import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { LOGIN_FLEET_OWNER } from '../../Services/cabapi/fleetggl'
import { MyContext } from '../../utils/context/TempAuth'

export default function SignIn() {
  const [email, setEmail] = useState('')
  const { auth } = useContext(MyContext)
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [forgotPassPopup, setForgotPassPopup] = useState(false)
  const navigate = useNavigate()

  const [loginFleetOwner, { loading }] = useLazyQuery(LOGIN_FLEET_OWNER)

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword)
  }

  const loginUser = async (e) => {
    e.preventDefault()

    if (email && password) {
      await loginFleetOwner({
        variables: { searchedString: email, password },
      }).then((res) => {
        if (res.error) {
          toast.error('Failed to login')
        }
        if (res?.data) {
          const userData = {
            firstName: res?.data?.loginFleetOwner?.firstName,
            lastName: res?.data?.loginFleetOwner?.lastName,
            fleetId: res?.data?.loginFleetOwner?._id,
            fleetMobileNumber: res?.data?.loginFleetOwner?.mobileNumber,
            token: res?.data?.loginFleetOwner?.authToken,
          }
          console.log('userData', userData)
          auth?.login(userData)
        }
      })
    } else {
      toast.error('Please fill in both fields')
    }
  }

  return (
    <div className="flex items-center justify-center h-[90vh]">
      <div className="bg-white rounded-md shadow sh p-4 md:p-8 lg:p-12 flex flex-col md:flex-row justify-between w-full max-w-[800px]">
        <div className="flex flex-col w-full md:w-2/3 lg:w-3/4">
          <div className="text-zinc-800 text-2xl font-bold font-segoe-ui mb-4 flex flex-start">
            Sign in
          </div>
          <div className="mb-4">
            <label className="text-stone-500 text-sm font-normal font-open-sans mb-1 flex flex-start w-full md:w-[374px]">
              Email/Mobile
            </label>
            <input
              autoFocus
              type="text"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="flex flex-start w-full md:w-[374px] border border-gray-200 h-[48px] bg-white rounded-md p-2 box-border text-stone-500 text-sm font-bold font-['Open Sans']"
            />
          </div>
          <div className="mb-3">
            <label className="text-stone-500 text-sm font-normal font-open-sans mb-2 flex flex-start w-full md:w-[374px]">
              Password*
            </label>
            <div className="relative md:w-[374px] ">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password} // Ensure value is controlled
                className="flex flex-start w-full md:w-[374px] border border-gray-200 h-[48px] bg-white rounded-md p-2 box-border text-stone-500 text-sm font-bold font-['Open Sans']"
                placeholder="Password"
                onChange={(event) => setPassword(event.target.value)}
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer bg-white"
              >
                {/* Add your eye icon here */}
              </button>
            </div>
          </div>

          <div className="mb-3 underline text-stone-500 text-sm font-normal font-open-sans flex justify-end w-full md:w-[374px]">
            <span
              onClick={() => setForgotPassPopup(true)}
              className="cursor-pointer"
            >
              Forgot Password ?
            </span>
          </div>
          <button
            className="mb-3 bg-sky-300 cursor-pointer rounded-3xl p-3 w-full md:w-[374px]"
            onClick={(e) => loginUser(e)} // Ensure loginUser is called on button click
            disabled={loading} // Optionally disable the button while loading
          >
            <div className="text-white text-sm font-bold font-segoe-ui break-words">
              {loading ? 'Signing in...' : 'Sign in'}
            </div>
          </button>
          <button
            className="mb-3 border cursor-pointer border-sky-300  rounded-3xl p-3 w-full md:w-[374px]"
            onClick={() => {
              navigate('/register-flet-owner')
            }} // Ensure loginUser is called on button click
          >
            <div className="text-sky-300 text-sm font-bold font-segoe-ui break-words">
              Sign up
            </div>
          </button>
        </div>

        <div className="hidden md:block">
          <img
            className="w-full md:w-[289px] h-auto mt-12"
            src="/signin.jpg"
            alt="IM"
          />
        </div>
      </div>
    </div>
  )
}
